import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { DASHBOARD_ROUTE } from "../../../../routes";
import DataTable from "../../common/data-table/data-table";
import { TASKS_ROUTE } from "../../dashboard-routes";

const DashboardIncompleteTaskTable = ({ data,isLoading }) => {
    const tableHeader = [
        { name: "Task Name", key: "title", style: { maxWidth: "30ch", minWidth: "20ch" } },
        // { name: "Details", key: "detail", style: { maxWidth: "30ch", minWidth: "20ch" } },
        { name: "Due Date", key: "deadlineInString" },
        // { name: "Completed By", key: "completedByName" },
        // { name: "Completed At", key: "completedOnString" },
        // { name: "Reminder Sent", key: "isReminderSent" },
    ];

    const [displayData, setDisplayData] = useState([]);

    useEffect(() => {
        let tasks = parseData(data);
        setDisplayData(tasks);
    }, [data]);

    function parseData(data) {
        let taskData = [];
        data.forEach((task) => {
            let {
                completedByName,
                deadline,
                desc,
                deadlineInString,
                title,
                taskType,
                isCompleted,
                completedOn,
                isReminderSent,
            } = task;

            let completedOnString;
            if (isCompleted && completedOn) {
                let date = new Date(completedOn._seconds * 1000);
                completedOnString =
                    date.toDateString().split(" ").slice(1).join(" ") + " - " + date.toTimeString().split(" ")[0];
            }

            let detail;
            let detailString;

            if (taskType === "memberLicenseExpiry") {
                detail = `License Expiry for ${task.metaData.name} ${task.metaData.licenceid}`;
                detailString = detail;
            } else {
                detail = desc;
                detailString = desc;
            }

            if (!completedOn) completedOn = "-";
            if (!completedByName) completedByName = "-";

            if (isCompleted === false) {
                completedByName = "-";
                completedOnString = "-";
            }

            taskData.push({
                completedByName,
                deadlineInString,
                title,
                detail,
                detailString,
                isReminderSent: isReminderSent ? "Yes" : "No",
                completedOnString,
                isCompleted,
                deadline: deadline._seconds,
            });
        });

        taskData = taskData.sort((a, b) => {
            if (a.deadline > b.deadline) return 1;
            else if (a.deadline < b.deadline) return -1;
            else return 0;
        });

        taskData = taskData.slice(0, 10);

        return taskData;
    }

    return (
        <div className="container-fluid p-3">
            <div className="card border-0">
                <div className="card-header py-3 d-flex bg-white align-items-center justify-content-between">
                    <b>Incomplete Tasks</b>
                    <Link className="btn btn-primary text-light" to={DASHBOARD_ROUTE + TASKS_ROUTE}>
                        View All Tasks
                    </Link>
                </div>
                <div className="card-body p-3">
                    {isLoading ? (
                        <div className="">
                            <div className="d-flex align-items-center justify-content-center">
                                <div className="me-3">Fetching Tasks</div>
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div style={{ overflow: "auto" }}>
                            <DataTable 
                                header={tableHeader} 
                                rawData={displayData}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DashboardIncompleteTaskTable;
